import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import * as React from 'react';
import { useTheme } from '@emotion/react';
import { motion, useAnimation } from 'framer-motion';
import clsx from 'clsx';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';
import useMount from 'react-use/lib/useMount';
import Button from './Button';
import { jsx as ___EmotionJSX } from "@emotion/react";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1h7qzhb",
  styles: "overflow:hidden;height:0"
} : {
  name: "1cgu8gn-Reveal",
  styles: "overflow:hidden;height:0;label:Reveal;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

const Reveal = _ref => {
  let {
    reveal,
    setReveal,
    children,
    className,
    onComplete = () => {},
    onReverseComplete = () => {},
    trigger = {
      props: {},
      label: ''
    }
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["reveal", "setReveal", "children", "className", "onComplete", "onReverseComplete", "trigger"]);

  const theme = useTheme();
  const triggerRef = React.useRef();
  const direction = React.useRef('forward');
  const controls = useAnimation();
  const variants = {
    hidden: {
      height: 0,
      opacity: 0
    },
    visible: {
      opacity: 1,
      height: 'auto'
    }
  };
  useMount(() => {
    if (reveal) {
      controls.set('visible');
      direction.current = 'forward';
    }
  });
  useUpdateEffect(() => {
    if (reveal) {
      controls.start('visible');
      direction.current = 'forward';
    } else {
      controls.start('hidden');
      direction.current = 'reverse';
    }
  }, [reveal]);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, _extends({
    ref: triggerRef,
    onClick: () => setReveal(!reveal),
    className: clsx({
      [theme.settings.classes.active]: reveal
    })
  }, trigger.props), trigger.label), ___EmotionJSX(motion.div, _extends({
    className: clsx('CK__Reveal', className),
    css: _ref2,
    "aria-hidden": reveal ? 'false' : 'true',
    variants: variants,
    animate: controls,
    initial: "hidden",
    transition: {
      type: 'tween',
      duration: theme.motion.timing.base
    },
    onAnimationComplete: () => direction.current === 'forward' ? onComplete() : onReverseComplete()
  }, rest), ___EmotionJSX("div", {
    className: "CK__Reveal__Content " + theme.settings.classes.trim
  }, children)));
};

export default Reveal;